import React from 'react';
import { Heart, Users, CheckCircle2, PoundSterling } from 'lucide-react';

const stats = [
  { icon: PoundSterling, label: 'Total Raised', value: '£0', sub: 'since launch', color: 'text-teal-600' },
  { icon: Users, label: 'Lives Impacted', value: '0', sub: 'individuals & families', color: 'text-teal-600' },
  { icon: Heart, label: 'Active Causes', value: '0', sub: 'verified & live now', color: 'text-amber-500' },
  { icon: CheckCircle2, label: 'Cases Resolved', value: '0', sub: 'fully funded', color: 'text-green-600' },
];

export default function StatsBar() {
  return (
    <div className="bg-white border-b border-gray-100 shadow-sm">
      <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-10 2xl:px-16">
        <div className="grid grid-cols-2 lg:grid-cols-4 divide-x divide-gray-100">
          {stats?.map((s) => (
            <div key={`stat-${s?.label}`} className="flex items-center gap-4 px-6 py-5">
              <div className={`p-2.5 rounded-xl bg-gray-50 ${s?.color}`}>
                <s.icon size={20} />
              </div>
              <div>
                <p className="font-mono text-2xl font-bold text-gray-900 tabular-nums">{s?.value}</p>
                <p className="text-xs font-medium text-gray-500">{s?.label}</p>
                <p className="text-xs text-gray-400">{s?.sub}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}